export default __webpack_public_path__ + "static/media/bank-tree.4d59987c.jpeg";